import { positionsInfoMiddleware } from "./positions-info-middleware";

export const positionsInfoMiddlewares = [positionsInfoMiddleware];
